import type { ReactNode } from "react";

/** 微信H5手机画布：桌面端居中，非设计稿iPhone外壳 */
export function PhoneLayout({ children }: { children: ReactNode }) {
  return (
    <div className="flex min-h-screen justify-center bg-ink-900/5">
      <div className="relative min-h-screen w-full max-w-phone bg-paper-warm shadow-raised">
        {children}
      </div>
    </div>
  );
}
